// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Page_navbar__zWaA4","page":"Page_page__iXzE6","pageWithHero":"Page_pageWithHero__Upd4B","heroImage":"Page_heroImage__1VwSH"};